import { data, type SignatureAddressGranularity } from './data';

export function getSignatureAddressGranularity(countryCode: string): SignatureAddressGranularity | undefined {
	// eslint-disable-next-line security/detect-object-injection
	return data.addressGranularity[countryCode];
}
